import { fetchAllTagData } from '../actions/routines';
import { call, put } from 'redux-saga/effects';
import Products from '../services/api/Products';

export function* fetchTagsSaga(action) {
    try {
        yield put(fetchAllTagData.request());

        const response = yield call(Products.getTags, action.payload);

        yield put(fetchAllTagData.success(response.data));
    } catch (error) {
        yield put(fetchAllTagData.failure(error.message));
    } finally {
        yield put(fetchAllTagData.fulfill());
    }
}
